import { Navigate, useLocation } from "react-router-dom";
import { localizePath, parseLocalizedPathname } from "@plaatplan/i18n";

export function NotFoundRedirect() {
  const location = useLocation();
  const { locale } = parseLocalizedPathname(location.pathname);

  return <Navigate to={localizePath("/", locale)} replace />;
}
